import { createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8317a57a")

_pushScopeId("data-v-8317a57a")
const _hoisted_1 = { class: "formularioCostos" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", { class: "text-primary" }, "Metropolitanas", -1)
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "sucursal",
  class: "form-label"
}, "Sucursal ", -1)
const _hoisted_10 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "checkAreasMetro"
}, " Seleccionar todas ", -1)
const _hoisted_13 = { class: "overflow-auto selector-sucursales" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h5", { class: "text-primary" }, "Interior de la República", -1)
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  for: "sucursal",
  class: "form-label"
}, "Sucursal ", -1)
const _hoisted_20 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "checkForanea"
}, " Seleccionar todas ", -1)
const _hoisted_23 = { class: "overflow-auto selector-sucursales" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-end" }, [
    /*#__PURE__*/_createVNode("p", { class: "" }, "Suma")
  ])
], -1)
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "d-flex justify-content-end" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createVNode("h5", { class: "text-primary" }, "Áreas", -1)
const _hoisted_33 = { class: "col-sm-12" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  for: "sucursal",
  class: "form-label"
}, "Área ", -1)
const _hoisted_35 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "checkAreas"
}, " Seleccionar todas ", -1)
const _hoisted_38 = { class: "overflow-auto selector-sucursales" }
const _hoisted_39 = { class: "col-sm-6" }
const _hoisted_40 = { class: "col-sm-6" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-end" }, [
    /*#__PURE__*/_createVNode("p", { class: "" }, "Suma")
  ])
], -1)
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = { class: "d-flex justify-content-end" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-8317a57a></div><div class=\"row\" data-v-8317a57a></div><div class=\"row\" data-v-8317a57a></div><div class=\"row\" data-v-8317a57a></div><div class=\"row\" data-v-8317a57a></div><div class=\"row\" data-v-8317a57a></div>", 6)
const _hoisted_51 = { class: "row bg-gray" }
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = { class: "d-flex justify-content-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selecionarMetro = $event)),
                    value: "metro",
                    id: "checkAreasMetro",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.LimpiarSeleccion($event)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.selecionarMetro]
                  ]),
                  _hoisted_12
                ]),
                _withDirectives(_createVNode("p", { class: "text-secondary" }, "Sucursales Metro seleccionadas " + _toDisplayString(_ctx.MetroElegidas.length) + " de " + _toDisplayString(_ctx.catalogos.Sucursales.filter((s) => !s.esForanea).length), 513), [
                  [_vShow, _ctx.MetroElegidas.length > 0]
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Sucursales.filter((s) => !s.esForanea), (metropolitana) => {
                  return (_openBlock(), _createBlock("label", {
                    class: "list-group-item opcion-selector",
                    key: metropolitana.clave
                  }, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input me-1",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.MetroElegidas = $event)),
                      type: "checkbox",
                      value: metropolitana,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ActualizarSeleccion()))
                    }, null, 40, ["value"]), [
                      [_vModelCheckbox, _ctx.MetroElegidas]
                    ]),
                    _createTextVNode(" " + _toDisplayString(metropolitana.nombre), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.MetroElegidas, (metro) => {
            return (_openBlock(), _createBlock("div", {
              class: "row",
              key: metro.clave
            }, [
              _createVNode("div", _hoisted_14, [
                _createVNode("input", {
                  type: "text",
                  class: "form-control",
                  value: metro.nombre,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => (metro.monto = $event),
                  class: "form-control"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, metro.monto]
                ])
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selecionarSucursalesForaneas = $event)),
                    value: "foranea",
                    id: "checkForanea",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.LimpiarSeleccion($event)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.selecionarSucursalesForaneas]
                  ]),
                  _hoisted_22
                ]),
                _withDirectives(_createVNode("p", { class: "text-secondary" }, "Sucursales Foraneas seleccionadas " + _toDisplayString(_ctx.ForaneasElegidas.length) + " de " + _toDisplayString(_ctx.catalogos.Sucursales.filter((s) => s.esForanea).length), 513), [
                  [_vShow, _ctx.ForaneasElegidas.length > 0]
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Sucursales.filter((s) => s.esForanea), (foranea) => {
                  return (_openBlock(), _createBlock("label", {
                    class: "list-group-item opcion-selector",
                    key: foranea.clave
                  }, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input me-1",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.ForaneasElegidas = $event)),
                      type: "checkbox",
                      value: foranea,
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ActualizarSeleccionForaneas()))
                    }, null, 40, ["value"]), [
                      [_vModelCheckbox, _ctx.ForaneasElegidas]
                    ]),
                    _createTextVNode(" " + _toDisplayString(foranea.nombre), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ForaneasElegidas, (foraneaelegida) => {
            return (_openBlock(), _createBlock("div", {
              class: "row",
              key: foraneaelegida
            }, [
              _createVNode("div", _hoisted_24, [
                _createVNode("input", {
                  type: "text",
                  class: "form-control",
                  value: foraneaelegida.nombre,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_25, [
                _withDirectives(_createVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => (foraneaelegida.monto = $event),
                  class: "form-control"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, foraneaelegida.monto]
                ])
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("p", null, "$ " + _toDisplayString(_ctx.formatoMoneda(_ctx.sumaSucursales)), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selecionarAreas = $event)),
                    value: "area",
                    id: "checkAreas",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.LimpiarSeleccion($event)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.selecionarAreas]
                  ]),
                  _hoisted_37
                ]),
                _withDirectives(_createVNode("p", { class: "text-secondary" }, "Áreas seleccionadas " + _toDisplayString(_ctx.AreasElegidas.length) + " de " + _toDisplayString(_ctx.catalogos.Areas.length), 513), [
                  [_vShow, _ctx.AreasElegidas.length > 0]
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.catalogos.Areas, (area) => {
                  return (_openBlock(), _createBlock("label", {
                    class: "list-group-item opcion-selector",
                    key: area.clave
                  }, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input me-1",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.AreasElegidas = $event)),
                      type: "checkbox",
                      value: area,
                      onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.ActualizarSeleccionAreas()))
                    }, null, 40, ["value"]), [
                      [_vModelCheckbox, _ctx.AreasElegidas]
                    ]),
                    _createTextVNode(" " + _toDisplayString(area.nombre), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.AreasElegidas, (areaelegida) => {
            return (_openBlock(), _createBlock("div", {
              class: " row",
              key: areaelegida
            }, [
              _createVNode("div", _hoisted_39, [
                _createVNode("input", {
                  type: "text",
                  class: "form-control",
                  value: areaelegida.nombre,
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_40, [
                _withDirectives(_createVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => (areaelegida.monto = $event),
                  class: "form-control"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, areaelegida.monto]
                ])
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                _createVNode("p", null, "$ " + _toDisplayString(_ctx.formatoMoneda(_ctx.sumaAreas)), 1)
              ])
            ])
          ]),
          _hoisted_45,
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode("div", _hoisted_53, [
                _createVNode("h4", null, "Total de factura sin IVA : $ " + _toDisplayString(_ctx.formatoMoneda(_ctx.sumaTotal)), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})